
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/agent-groups/agentGroupMoveGridView.tmpl");
    var AgentGroupMoveGridRowView = require("user-management-views/agent-groups/AgentGroupMoveGridRowView");
    var AgentGroupsGridEmptyView = require("user-management-views/agent-groups/AgentGroupsGridEmptyView");

    var AgentGroupMoveGridView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupMoveGridView = Marionette.GridView.extend({
            className: "table-main ui-table",
            template: template,
            itemViewContainer: "tbody",
            itemView : AgentGroupMoveGridRowView,
            emptyView: AgentGroupsGridEmptyView,
            selectedItem:null,

            initialize: function(options) {

            },

            onRender: function() {
                // this is a hack because you have to call the "filter" in order to the filter icon to be colored
                if (!_.isEmpty(this.model.changed.filters)) {
                    this.filter(this.model);
                }
            },

            onCompositeCollectionRendered:function(){
                _.each(this.collection.getSelected(), function(selectedModel){
                    if (!_.isEmpty(this.children.findByModel(selectedModel))) {
                        selectedModel.trigger("model:selection:change", true);
                    }
                }, this);
            }
        });

    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupMoveGridView;
});